import _Affix from './Affix';

import './style/index.js';

export type { AffixProps, AffixRef } from './Affix';
export * from './type';

export const Affix = _Affix;
export default Affix;
